import { useState } from "react";

import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

import IInvoiceConfirmation from "assets/i-invoice-confirmation.png";
import XIconSrc from "assets/cross.svg";

const ModalKonfirmasiPembayaran = ({
  onClose,
  isOpen,
  onConfirm,
  ...props
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleConfirm = () => {
    if (isChecked) {
      onConfirm?.();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[480px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-end px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <img
            src={XIconSrc}
            alt="Close"
            onClick={onClose}
            className="cursor-pointer"
          />
        </div>

        <div className="px-6 py-2 flex flex-col items-center">
          <img
            src={IInvoiceConfirmation}
            alt="Invoice Confirmation"
            className="w-[120px] h-auto mb-4"
          />

          <h2 className="text-[22px] font-inter-semibold text-[#252526] mb-2 text-center">
            Lanjutkan Pembayaran?
          </h2>

          <p className="text-[13px] font-inter text-[#808285] text-center">
            Sebelum melanjutkan pembayaran, pastikan informasi GCC, Invoice, dan
            PC (Personal Commission) sudah benar.
          </p>
        </div>

        <div className="flex items-center gap-[16px] justify-end gap-3 px-4 py-3 border-t border-solid border-[#D8D8D9]">
          <label className="flex items-start gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              className="mt-1 w-4 h-4 cursor-pointer checked:bg-[#02AC5B]"
            />
            <span className="text-[13px] font-inter text-[#252526] w-[280px]">
              <span className="text-[#FD4949] font-inter-semibold">*</span>Dengan ini saya menyatakan bahwa informasi yang ditampilkan sudah
              sesuai.
            </span>
          </label>
          <Button
            type="primary"
            text="Bayar Sekarang"
            onClick={handleConfirm}
            disabled={!isChecked}
            size="s"
          />
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalKonfirmasiPembayaran isOpen={isOpen} {...props} />;
};

export default Wrapper;
